import React from 'react';

export default function Microphone(props) {
  const fillColor = props.fillColor || '#D0021B';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="23" viewBox="0 0 16 23">
      <path fill={fillColor} fillRule="nonzero" d="M16 10.175v1.213c0 3.798-3.02 7.93-6.693 8.159v.803l1.621.901V23H5.072v-1.749l1.62-.9v-.804C3.02 19.317 0 15.187 0 11.387v-1.212h1.725v1.213c0 3.45 2.82 6.368 6.175 6.418h.2c3.355-.059 6.175-2.976 6.175-6.418v-1.213H16zm-8 5.936c2.535 0 4.601-2.086 4.601-4.639V4.638C12.601 2.078 10.535 0 8 0S3.399 2.077 3.399 4.638v6.834c0 2.561 2.066 4.639 4.601 4.639z" />
    </svg>

  );
}



// WEBPACK FOOTER //
// ./src/components/Iconoclast/Microphone/index.js